import { Data$, RemoteData } from '@lycoris-nubila/ngx-lycoris';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';

import { CommandEvent } from 'application/common/model/command-event';
import { CreateCoachMeetingCmd } from 'task/command/create-coach-meeting.cmd';
import { CreateJobOfferMeetingCmd } from 'task/command/create-job-offer-meeting.cmd';
import { CreateTodoTaskCmd } from 'task/command/create-todo-task.cmd';
import { MoveTaskCmd } from 'task/command/move-task.cmd';
import { FetchTasksQuery } from 'task/query/fetch-tasks.query';
import { ObserveSearchedUserCoachMeetingsQuery } from 'task/query/observe-searched-user-coach-meetings.query';
import { ITask, Task } from 'task/task';

import { CreateContactMeetingCmd } from '../command/create-contact-meeting.cmd';

export abstract class TaskApplicationPort {
	public abstract fetchDayTasks(date: string): Observable<string[] | Error>;

	public abstract observeDayTasks(date: DateTime): Observable<ITask[]>;

	public abstract createContactMeeting(
		cmd: CreateContactMeetingCmd
	): Observable<void>;

	public abstract createJobOfferMeeting(
		cmd: CreateJobOfferMeetingCmd
	): Observable<void>;

	public abstract deleteTask(id: string): Promise<void>;

	public abstract markTaskDone(id: string): Promise<void>;

	public abstract markTaskPending(id: string): Promise<void>;

	public abstract fetchUserOverdueTasks(
		userId: string
	): Observable<string[] | Error>;

	public abstract observeUserOverdueTasks(userId: string): Observable<ITask[]>;

	public abstract observeUserPendingTasks(
		userId: string
	): Observable<RemoteData<ITask[]>>;

	public abstract observeContactTasks(contactId: string): Data$<ITask[]>;

	public abstract observeTask(taskId: string): Observable<RemoteData<ITask>>;

	public abstract createCoachMeeting(
		cmd: CreateCoachMeetingCmd
	): Observable<void>;

	public abstract createTodoTask(cmd: CreateTodoTaskCmd): Observable<string>;

	public abstract moveTask(cmd: MoveTaskCmd): Observable<ITask>;

	public abstract fetchTasks(
		query: FetchTasksQuery
	): Observable<string[] | Error>;

	public abstract observeTasks(tasksId: string[]): Observable<ITask[]>;

	public abstract observeJobOfferTasks(jobOfferId: string): Data$<ITask[]>;

	public abstract saveTasks(ids: string[]): Promise<void>;

	public abstract observeUserCoachMeetings(
		meetingsId: string[]
	): Observable<Task[]>;

	public abstract searchUserCoachMeetings(
		query: ObserveSearchedUserCoachMeetingsQuery
	): Observable<string[] | Error>;

	public abstract commandHandled$: Observable<CommandEvent<TaskApplicationPort>>;
}
